(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emiliaz-home-campaign"] && !Shopify.designMode) return;
  try {
    
(() => {
  const starts = [Date.parse('2026-11-04T00:00:00Z'), Date.parse('2026-11-20T00:00:00Z'), Date.parse('2026-11-30T00:00:00Z')];
  let rollover;
  const update = () => {
    clearTimeout(rollover);
    const now = Date.now();
    document.querySelectorAll('.ez-hp-switch').forEach(root => {
      const mode = root.dataset.ezHpMode;
      const phase = mode === 'automatic' ? (now >= starts[0] && now < starts[1] ? 'festive' : now >= starts[1] && now < starts[2] && root.dataset.bfEnabled === 'true' ? 'black-friday' : '') : mode;
      root.querySelectorAll('[data-ez-hp-phase]').forEach(art => { art.hidden = art.dataset.ezHpPhase !== phase; });
      root.hidden = !phase;
      const style = root.querySelector('[data-ez-slideshow-style]');
      if (style) style.textContent = phase ? '#' + CSS.escape(root.dataset.slideshowId) + '{display:none!important}' : '';
    });
    const next = starts.find(time => time > now);
    if (next) rollover = setTimeout(update, Math.min(next - now + 20, 2147483647));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
  document.addEventListener('shopify:section:load', update);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emiliaz-privacy-policy"]) return;
  try {
    
  function showEmiliazCookieControls() {
    if (typeof window.privacyBanner?.showPreferences !== 'function') return;
    document.querySelectorAll('[data-emiliaz-cookie-preferences]').forEach((button) => {
      button.hidden = false;
    });
  }
  showEmiliazCookieControls();
  window.addEventListener('load', showEmiliazCookieControls);
  document.addEventListener('customerPrivacyApiLoaded', showEmiliazCookieControls);
  document.addEventListener('shopify:section:load', showEmiliazCookieControls);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-emiliaz-cookie-preferences]');
    if (button && typeof window.privacyBanner?.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
